<style scoped>
	#app {
		padding: 20px;
	}
	.header {
		line-height: 60px;
		font-size: 16px;
		font-weight: bold;
		
	}
	.table-box {
		margin-top: 10px;
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
	}
	
	.table-header {
		padding: 15px 20px;
		font-size: 14px;
		font-weight: bold;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	
	.box {
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
		display: flex;
		flex-wrap: wrap;
		padding: 10px 0;
		font-size: 14px;
	}
	.form-item {
		height: 60px;
		width: 380px;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.form-name {
		width: 120px;
		text-align: right;
	}
	.inp {
		width: 280px;
	}
	.el-button--primary {
		background-color: #1677FF!important;
	}
	.dot {
		color: #52C51A;
		padding: 10px;
	}
	.il {
		display: flex;
		flex-direction: row;
	}
	.t-box {
		border: solid 1px #dcdcdc;
		padding: 0 4px;
		border-radius: 4px;
	}
	.t-box1 {
		border: solid 1px #3da113;
		color: #3da113;
		padding: 0 4px;
		border-radius: 4px;
		background-color: #F7FFFE;
	}
	.t-edit {
		font-size: 14px;
		padding: 0 4px;
		margin-left: 10px;
		cursor: pointer;
	}
	.t-a {
		color: #1677FF;
		text-decoration: underline;
		cursor: pointer;
	}
</style>
<template>
	<div id="app">
		<el-breadcrumb class="nav" separator="/" style="margin-bottom: 13px;">
			<el-breadcrumb-item>开发配置</el-breadcrumb-item>
			<el-breadcrumb-item>胜负过关开奖</el-breadcrumb-item>
		</el-breadcrumb>
		
		<div style="background-color: white; padding: 20px;">
			<el-upload class="upload-demo" ref="upload"
			  :action="this.$http_host + '/Admin/Upload/uploadImage'" :headers="headers" 
			  :on-preview="handlePreview"
			  :on-remove="handleRemove"
			  :file-list="fileList"
			  :on-success="UploadSuccess"
			  :auto-upload="false">
			  <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
			  <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传文件</el-button>
			   <el-button style="margin-left: 10px;" size="small" type="warning" @click="uploadFileAnalysis">解析赛果</el-button>
			   <el-button style="margin-left: 10px;" size="small" type="danger" @click="confirmData">同步赛果</el-button>
			  <div slot="tip" class="el-upload__tip">选择270后，点击"上传到服务器"完成后点击"解析赛果"，解析完赛果确认无误后点击"上传赛果"</div>
			</el-upload>
		</div>
		
		<div class="table-box">
			<el-table :data="tableData" border 
				v-loading="loading"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)" >
				<el-table-column prop="match_id" label="比赛ID" align="center" width="120"></el-table-column>
				<el-table-column prop="status" label="主队 VS 客队" align="center"  width="220">
					<template slot-scope="scope">
						{{scope.row.host}} VS {{scope.row.guest}}
					</template>
				</el-table-column>
				
				<el-table-column prop="score" label="比分" align="center">
				</el-table-column>
				
				<el-table-column prop="tags" label="赛果" align="center">
					<template slot-scope="scope">
						<div>
							<div>{{scope.row.sf_format}}</div>
						</div>
					</template>
				</el-table-column>
				
				<el-table-column prop="tags" label="赛果" align="center">
					<template slot-scope="scope">
						<div>
							<div>{{scope.row.sf}}</div>
						</div>
					</template>
				</el-table-column>
	
				
			  </el-table>
			  
		</div>
	</div> 
</template>

<script>
	export default {
		data(){
			return {
				xmlList:[],
				fileList:[],
				loading:false,
				currentPage:1,
				tableData: [],
				total:0,
				limit:10,
				headers:{
					Authorization:'',
				}
			}
		},
		created() {
			this.headers.Authorization = localStorage.getItem('access_token');
		},
		methods:{
			uploadData(){
				let that = this;
				that.loading = true;
				that.$api.post("/Open/uploadWinloseList", {list: JSON.stringify(this.tableData)}).then(res=>{
					that.loading = false;
					if(res.code == 200){
						that.$message({ message: res.msg, type: 'success' });
					}else{
						that.$message({ message: res.msg, type: 'warning' });
					}
				}).catch(res=>{
					that.loading = false;
				});
			},
			confirmData(){
				if(this.tableData.length == 0){
					return this.$message({ message: '无赛果数据同步', type: 'warning' });
				}
				let _this = this;
				this.$confirm('请检查赛果数据是否完整，是否确认同步赛果数据?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					_this.uploadData();
				}).catch(() => {      
				});
			},
			uploadFileAnalysis(){
				if(this.xmlList.length != 1){
					return this.$message({ message: '请上传完整270.xml文件', type: 'warning' });
				}
				let that = this;
				that.loading = true;
				that.$api.post("/Open/uploadPekingFiles", {files: JSON.stringify(this.xmlList)}).then(res=>{
					that.loading = false;
					if(res.code == 200){
						that.tableData = res.data.list;
						that.total = res.data.count;
					}else{
						that.$message({ message: res.msg, type: 'warning' });
					}
				}).catch(res=>{
					that.loading = false;
				});
			},
			UploadSuccess(res, file, fileList){
				if(res.code == 200)
				{
					this.xmlList.push(res.data.url);
				}else{
					return this.$message({ message: res.msg, type: 'warning' });
				}
			},
			submitUpload() {
				this.$refs.upload.submit();
			},
			handleRemove(file, fileList) {
				this.xmlList = this.xmlList.filter( item => item != file.response.data.url );
			},
			handlePreview(file) {
				console.log(file);
			}
		}
	}
</script>

